/**
 * Opens a file that has to be fetched first in a new tab. The tab opens before the fetch, as part of the click, so
 * the browser does not block it as a popup. The object URL is released after a minute, once the tab has loaded it.
 */
export const openFetchedInNewTab = async (fetchObjectUrl: () => Promise<string>): Promise<void> => {
    const tab = window.open('', '_blank')
    if (tab) tab.opener = null
    try {
        const url = await fetchObjectUrl()
        if (tab) tab.location.href = url
        else window.open(url, '_blank', 'noopener,noreferrer')
        window.setTimeout(() => URL.revokeObjectURL(url), 60_000)
    } catch (error) {
        tab?.close()
        throw error
    }
}

/** Trigger a browser download of an in-memory Blob via a temporary object URL. */
export const downloadBlob = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
    // Not at once: Safari can still be reading the file after click() returns, and the download then fails.
    window.setTimeout(() => window.URL.revokeObjectURL(url), 40_000)
}
